import { render, staticRenderFns } from "./sysparam.vue?vue&type=template&id=071cc00a&"
import script from "./sysparam.vue?vue&type=script&lang=js&"
export * from "./sysparam.vue?vue&type=script&lang=js&"
import style0 from "./sysparam.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports